<template>
  <div>
     <div class="p-4 max-w-main bg-vmain" style="min-height: calc(100vh - 62px);">
        <img @click="$router.push('/')" class="cursor-pointer" src="@/assets/default_main/logo1.svg" />
        <div class="text-center mt-4">
            <div class="mt-3">
                <div class="text-center">
                    <p class="text-lg"><b>Chúc mừng!<br>Đã tìm thấy khoản vay phù hợp với bạn<br>tại Lotte Finance</b></p>
                </div>
            </div>
            <!-- <div>
                <img class="cursor-pointer" src="@/assets/default_main/mirae_asset_logo.png" />
            </div>
            <div>
                <p>Để khoản vay được duyệt nhanh hơn, vui lòng truy cập Mirae Asset để bổ xung hồ sơ. Xin cảm ơn!</p>
            </div>
            <div class="mt-4 text-center">
                <button @click="redirectMirae" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg"> Bổ sung hồ sơ vay </button>
            </div>

            <div class="border-gray-200 border-2 p-2 rounded-lg mt-3 w-48 m-auto">
                <button @click="$router.push('/')" class="font-bold" > Về trang chủ</button>
            </div>
            <div class="contact-info">
                <p>Đối tác giải ngân của Vclick sẽ liên hệ hỗ trợ bạn trong vòng 24h tới, thời gian liên hệ từ <b>8h - 17h.</b></p>
                <p>Bạn vui lòng gọi hotline <b>190063337</b> nếu cần hỗ trợ</p>
            </div> -->
            <b-modal hide-header centered hide-footer no-close-on-backdrop id="modal-pending">
                <div class="text-left mb-26">
                    <div class="color-bold-vmain text-xl font-bold mt-3">
                        Cảm ơn bạn đã để lại thông tin
                    </div>
                    <div class="contact-info">
                        <p>Đối tác giải ngân của Vclick sẽ liên hệ hỗ trợ bạn trong vòng 24h tới, thời gian liên hệ từ <b>8h - 17h.</b></p>
                        <p>Bạn vui lòng gọi hotline <b>190063337</b> nếu cần hỗ trợ</p>
                    </div>
                    <div>
                        <a href="https://mafc.com.vn/vay-tien-nhanh/?utm_source=VD07">
                            <img alt="blog image" class="inline-block" src="@/assets/default_main/mirae.png" >
                        </a>
                    </div>
                    <div class="rounded-lg mt-3 w-48 m-auto">
                        <button @click="$router.push('/')" class="bg-color-vmain text-white font-bold text-center w-full p-2 rounded-md shadow-lg" > Về trang chủ</button>
                    </div>
                </div>
            </b-modal>
        </div>
     </div>
  </div>
</template>

<script>
import {getPartner,getMoney,getLogo,getToken, getPhone} from '@/utils/auth'
import {sendFile,saveCustomer,getInforKyc, getAddressInfo} from '@/api/otp'
import TimaRegister from '../components/tima_register.vue'
//import DatePick from '@/components/datePick.vue'
//import DatePick from '../../components/datePick.vue'
// import DatePick from 'vue-date-pick';
// import 'vue-date-pick/dist/vueDatePick.css';
import { toDMY,toYMD,toYMDHMS,toYMD2  } from "@/filters/index"

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
    components: {DatePicker,TimaRegister },
    data() {
        return {
        }
    },
    mounted() {
        this.$bvModal.show('modal-pending')
    },
    methods: {
        redirectMirae(){
            window.location.href = 'https://mafc.com.vn/vay-tien-nhanh/?utm_source=VD07'
        }
    },
}
</script>

<style>
.mx-input-wrapper {
    height: 56px;
}
.contact-info {
    padding: 26px 2px;
    border-bottom: 1px solid rgb(214, 217, 219);
    margin-bottom: 26px;
}
.contact-info p{
    margin-bottom: 26px;
    font-size: 18px;
}
.text-left {
    margin-bottom: 26px;
}

.mx-input{
    height: 52px;
    font-size: 16px;
}
.mt-3 {
    margin-top: 2rem !important;
}

.mx-datepicker{
    width: 100%;
}

.border-input-success .mx-input{
    height: 52px;
    font-size: 16px;
    color: green;
}

.mx-icon-calendar {
    top: 45%;
}

.vs__dropdown-toggle {
    height: 100%;
}

.vs__search {
    color: #9AA0A5;
}

.vs--single .vs__selected {
    background-color: transparent;
    border-color: transparent;
    color: green;
}

/* .date-pick input {
    height: 56px;
    width: 100%;
    font-size: 16px;
    border: 1px solid rgb(214, 217, 219);
    border-radius: 6px;
    padding: 12px;
} */
</style>